export class CircleChartData {
  name?: string;
  value: number;
  lineColor: string;
}

export class PieChartData {
  name: string;
  y: number; // value
  fracDigit?: number;
}

export class GenderPerAgeChartData {
  range: string; // range of age
  f: number; // female
  m: number; // male
}

export class NegativeStackBarChartSeries {
  name: string;
  data: Array<number>;
}

export class MentionTimeLineReportItem {
  keyword_type: string;
  date: number;
  appear: number;
}



// WEBPACK FOOTER //
// ./src/models/chart.ts